import service from './request';
import { cachedRequest } from './cache';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface SolutionFeature {
  icon: string;
  name: string;
  desc: string;
}

export interface SubSolution {
  id: string;
  name: string;
  desc: string;
  image: string;
  features: SolutionFeature[];
  scenarios: string[];
  benefits: { value: string; label: string }[];
}

export interface SolutionCategory {
  id: string;
  icon: string;
  tag: string;
  title: string;
  subtitle: string;
  desc: string;
  image: string;
  features: SolutionFeature[];
  subSolutions: SubSolution[];
}

export interface SubScene {
  id: string;
  icon: string;
  name: string;
  desc: string;
  tags: string[];
  productCategory: string;
  image: string;
  parentCategory: string;
  parentName: string;
  accentColor: string;
  heroImage: string;
  introduction: string;
  introTags?: string[];
  introImage?: string;
  painPointsImage?: string;
  painPoints?: { icon: string; title: string; desc: string }[];
  features: { icon: string; title: string; desc: string }[];
  benefits: { icon: string; title: string; value: string; desc: string }[];
  relatedCaseSolution: string;
}

// ─── API calls ────────────────────────────────────────────────────────────────

export function getSolutionTree(): Promise<SolutionCategory[]> {
  return cachedRequest('solutions/tree', () => service.get('/api/front/solutions'));
}

export function getSolutionDetail(id: string): Promise<any> {
  return service.get('/api/front/solutions/' + id);
}

export function getSceneDetail(sceneId: string): Promise<SubScene> {
  return service.get('/api/front/solutions/scenes/' + sceneId);
}

// 分类核心优势（为什么选择我们）
export function getCategoryAdvantage(category: string): Promise<any> {
  return service.get('/api/front/solutions/advantages/' + category);
}
